import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: ${({ $size }) => $size || '20px'};
  height: ${({ $size }) => $size || '20px'};
  border: 2.5px solid rgba(255, 255, 255, 0.2);
  border-top-color: ${({ theme }) => theme.colors.pinkSoft};
  border-radius: 50%;
  animation: ${spin} 700ms linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 1400ms;
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.red};
  background: rgba(255, 77, 77, 0.1);
  border: 1px solid rgba(255, 77, 77, 0.35);
  border-radius: 10px;
  padding: 0.75em 1em;
  font-size: 0.9rem;
  margin: 0 0 1rem;
`;

export const SuccessMessage = styled.p`
  color: ${({ theme }) => theme.colors.green};
  background: rgba(61, 220, 151, 0.1);
  border: 1px solid rgba(61, 220, 151, 0.35);
  border-radius: 10px;
  padding: 0.75em 1em;
  font-size: 0.9rem;
  margin: 0 0 1rem;
`;
